export const modifiedDifficultyofChallenge = (difficultyWithLevel?: string) => {
  if (!difficultyWithLevel) return ''
  return difficultyWithLevel.replace('_level', '').toLowerCase()
}
